import store from '@/store'
import currenciesService from '@/services/currencies'
const loadingKeys = {
    fetchingCurrencies: 'fetching-currencies',
}
export default {
  data() {
    return {
      browser_locale: window.navigator.language,
      currencySelect: '',
      keys:''
    }
  },

  computed: {
        isAuthenticated() {
            return store.getters['session/isAuthenticated']
        },
        
         currency() {
            return store.getters['currency/currentCurrency']
        },
        
  },
   mounted() {
     this.fetchCurrency()
     this.initCurrency()
  },

  methods: {
    initCurrency(obj) {
      let currencies = this.isAuthenticated && obj ? 
      {
            id: obj.id,
            key: obj.key,
            name: obj.name,
            definition: {
              symbol: JSON.parse(obj.definition).symbol
            }
      } :
      {
            id: this.convertLang(this.browser_locale)!== 'pt' ? 2 : 1,
            key: this.convertLang(this.browser_locale) !== 'pt' ? 'usd' : 'aoa',
            name:
                this.convertLang(this.browser_locale) !== 'pt'
                    ? 'united states dollar'
                    : 'kwanza',
            definition: {
                symbol:
                    this.convertLang(this.browser_locale) !== 'pt' ? '$' : 'Kz',
                locale:
                    this.convertLang(this.browser_locale) !== 'pt'
                        ? 'en-GB'
                        : 'pt-AO',
            },
      }
            store.commit('currency/setCurrency', currencies)
    },

    async fetchCurrency() {
            this.loadingAdd(loadingKeys.fetchingCurrencies)

            let parameters = {}

            let response = await currenciesService.retrieve(parameters)

            if (response.status === 200) {
                this.keys = response.data.results
                this.currencySelect = this.currency
                store.commit('currency/setList', this.keys)
            }

            this.loadingRemove(loadingKeys.fetchingCurrencies)
    },

    convertLang(langBrowser) {
          return langBrowser.substr(0, 2)
    }
    
  },
  
}